import React from "react";
import { Box, withStyles } from "@material-ui/core";

const styles = theme => ({
  root: {
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    color: theme.palette.primary.main, // blue color
  },
});

function ReferralWardRequestLabel(props) {
  const { classes } = props;

  return (
    <Box className={classes.root}>
      Ward Request
    </Box>
  );
}

export default withStyles(styles)(ReferralWardRequestLabel);
